import base from '@/http/url_base';

export default {
  SOURCING: base.API_ACHAT + '/sourcings',
  GET_REQUIREMENTS: base.API_ACHAT + '/sourcings/requirements',
  CLOTURER: base.API_ACHAT + '/sourcings/cloturer',
  REINITIALISER: base.API_ACHAT + '/sourcings/reinitialiser',

  UPDATE_CATALOGUE: base.API_ACHAT + '/sourcings/update-catalogue',
};
